import { render, staticRenderFns } from "./BrokersBankTransferReport.vue?vue&type=template&id=66c094cc&scoped=true&"
import script from "./BrokersBankTransferReport.vue?vue&type=script&lang=js&"
export * from "./BrokersBankTransferReport.vue?vue&type=script&lang=js&"
import style0 from "./BrokersBankTransferReport.vue?vue&type=style&index=0&id=66c094cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c094cc",
  null
  
)

export default component.exports